import { pluck, filter, map } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { roomTypes } from '../../../actions/room/roomTypes'
import { ReduxAction, State } from '../../../reducers/reducerType'
import trackActions from '../../../actions/tracks'

/** If a dialed-in presenter joins and it's not you but you are dialed-in */
export const notifyLocalPresenterWhenNewDialInParticipantEnters$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => action$.pipe(
  ofType(roomTypes.SET_DIALED_IN_PRESENTER),
  pluck<ReduxAction, string>('payload'),
  filter((identity) =>
    state$.value.user.BTID !== null &&
    state$.value.room.dialedInParticipants.includes(state$.value.user.BTID) &&
    state$.value.syncUi.mute.includes(state$.value.user.BTID) &&
    !identity.includes(state$.value.user.BTID)
  ),
  map(() => trackActions.sendDialInMuteNotification())
)

export default notifyLocalPresenterWhenNewDialInParticipantEnters$
